export default __webpack_public_path__ + "static/media/farmer_banner.539494b3.png";